(() => {
  const roots = document.querySelectorAll('.vbrand');
  if (!roots.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let scrollFrame = 0;

  const cancelScroll = () => {
    if (!scrollFrame) return;
    window.cancelAnimationFrame(scrollFrame);
    scrollFrame = 0;
  };

  const getHeaderOffset = () => {
    const candidates = document.querySelectorAll(
      '.section-header, sticky-header, .header-wrapper, header.header'
    );

    return Array.from(candidates).reduce((offset, element) => {
      const style = window.getComputedStyle(element);
      if (style.position !== 'fixed' && style.position !== 'sticky') return offset;

      const rect = element.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return offset;
      return Math.max(offset, Math.ceil(rect.bottom));
    }, 0);
  };

  const getTarget = (hash) => {
    try {
      return document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (error) {
      return null;
    }
  };

  const scrollToTarget = (target) => {
    cancelScroll();

    const targetPosition = target.getBoundingClientRect().top + window.scrollY;
    const getDestination = () => Math.max(0, targetPosition - getHeaderOffset() - 16);
    const start = window.scrollY;
    const distance = getDestination() - start;

    if (reducedMotion.matches || Math.abs(distance) < 2) {
      window.scrollTo(0, targetPosition);
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = 0;
        window.scrollTo(0, getDestination());
      });
      return;
    }

    const duration = Math.min(900, Math.max(500, Math.abs(distance) * 0.35));
    const startedAt = performance.now();

    const step = (now) => {
      const progress = Math.min((now - startedAt) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 4);
      window.scrollTo(0, start + (getDestination() - start) * eased);

      if (progress < 1) {
        scrollFrame = window.requestAnimationFrame(step);
      } else {
        scrollFrame = window.requestAnimationFrame(() => {
          scrollFrame = 0;
          window.scrollTo(0, getDestination());
        });
      }
    };

    scrollFrame = window.requestAnimationFrame(step);
  };

  roots.forEach((root) => {
    root.addEventListener('click', (event) => {
      const link = event.target.closest('a[href*="#"]');
      if (
        !link ||
        !root.contains(link) ||
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) return;

      const url = new URL(link.href, window.location.href);
      if (
        url.origin !== window.location.origin ||
        url.pathname !== window.location.pathname ||
        url.search !== window.location.search ||
        !url.hash ||
        url.hash === '#'
      ) return;

      const target = getTarget(url.hash);
      if (!target) return;

      event.preventDefault();
      if (window.location.hash !== url.hash) {
        window.history.pushState(null, '', url.hash);
      }
      scrollToTarget(target);
    });
  });

  window.addEventListener('wheel', cancelScroll, { passive: true });
  window.addEventListener('touchstart', cancelScroll, { passive: true });
  window.addEventListener('pointerdown', cancelScroll, { passive: true });
  window.addEventListener('resize', cancelScroll, { passive: true });
  window.addEventListener('pagehide', cancelScroll, { passive: true });

  document.addEventListener('keydown', (event) => {
    if (['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) {
      cancelScroll();
    }
  });

  if (reducedMotion.matches) return;

  document.documentElement.classList.add('vbrand-enhanced');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  roots.forEach((root) => {
    root.querySelectorAll('[data-vbrand-reveal]').forEach((element) => observer.observe(element));
  });
})();
